(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
        n.callMethod ?
            n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0'

    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s)
}(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
)
function metaFunc() {
    if (!window.fbq) {
        // Si `fbq` no existe, lo inicializamos como una función
        window.fbq = function () {
            (window.fbq.queue = window.fbq.queue || []).push(arguments);
        };
        // Propiedades adicionales de `fbq`
        window.fbq.queue = [];
        window.fbq.loaded = false;
        window.fbq.version = '2.0';
    }
    return window.fbq;
}
const fbq = metaFunc();

const isFbqDefined = () => typeof fbq === 'function';

fbq('init', '914711364116194')
fbq('track', 'PageView');

// Evento para el registro (sign_up)
export const trackSignUpMeta = (email, cuit) => {
    if (isFbqDefined()) {
        fbq('track', 'CompleteRegistration', {
            method: 'email', // Método utilizado para el registro (opcional)
            email: email,
            cuit: cuit,
        });
    } else {
        console.error('Meta Pixel no está definido');
    }
};

// Evento para añadir al carrito (add_to_cart)
export const trackAddToCartMeta = (product, quantity) => {
    if (isFbqDefined()) {
        fbq('track', 'AddToCart', {
            currency: 'ARS',
            value: product.unitPrice * quantity,
            content_ids: [product.productId],
            content_type: 'product',
            contents: [
                {
                    id: product.productId,
                    quantity: quantity,
                    name: product.productDescription,
                    price: product.unitPrice,
                },
            ],
        });
    } else {
        console.error('Meta Pixel no está definido');
    }
};

// Evento para iniciar el proceso de compra (begin_checkout)
export const trackBeginCheckoutMeta = (items, totalValue) => {
    if (isFbqDefined()) {
        fbq('track', 'InitiateCheckout', {
            currency: 'ARS',
            value: totalValue,
            contents: items.map(item => ({
                id: item.productId,
                quantity: item.quantity,
                name: item.productDescription,
                price: item.unitPrice,
            })),
            num_items: items.length,
        });
    } else {
        console.error('Meta Pixel no está definido');
    }
};

// Evento para confirmar una compra (purchase)
export const trackPurchaseMeta = (transactionId, items, totalValue, tax) => {
    if (isFbqDefined()) {
        fbq('track', 'Purchase', {
            currency: 'ARS',
            value: totalValue,
            transaction_id: transactionId,
            content_type: 'Purchase',
            contents: items.map(item => ({
                id: item.productId,
                quantity: item.quantity,
                name: item.productDescription,
                price: item.unitPrice,
            })),
        });
    } else {
        console.error('Meta Pixel no está definido');
    }
};